import React from "react";
import {Form, InputNumber} from "antd";
import {MIN_VALUE_RULE_NAME} from "@reside/forms/dist/validator/validators/minValueValidator";

import {
  useFocusedNode,
  useSetFocusedNodePropertyValue,
} from "../../model/editor";
import {getRuleValue, isCurrencyNode, updateRules} from "../../utils";
import {FormControlSourceNode} from "../../model/schemaTypes";

export const getMinValueRuleValue = getRuleValue(MIN_VALUE_RULE_NAME, parseInt);

export const getInitialMinValueFormValue = (node: FormControlSourceNode) => {
  try {
    return {
      [MIN_VALUE_RULE_NAME]: getMinValueRuleValue(node.rules),
    };
  } catch {
    return {};
  }
};

export const MinValueAttribute = () => {
  const node = useFocusedNode();
  const setValidationRules = useSetFocusedNodePropertyValue("rules");

  if (!node) {
    return null;
  }

  return isCurrencyNode(node) ? (
    <Form.Item
      name={MIN_VALUE_RULE_NAME}
      label="Min value"
      rules={[{type: "number", min: 0}]}
    >
      <InputNumber
        min={0}
        onChange={value =>
          setValidationRules(
            updateRules(
              [...(node.rules ?? [])],
              `${value ?? ""}`,
              MIN_VALUE_RULE_NAME,
            ),
          )
        }
      />
    </Form.Item>
  ) : (
    <>
      Attribute "${MIN_VALUE_RULE_NAME}" can be used only with FORM_CONTROL
      CURRENCY type
    </>
  );
};
